module.exports = "<img alt=\"{{$ctrl.altImg}}\"\r\n     class=\"{{$ctrl.cssClass}}\" />\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/lsp-image/lsp-image.html
// module id = 1868
// module chunks = 0